// src/components/ProductsPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import products from '../productData';
import '../styles/Productpage.css';

const ProductsPage = () => {
  const navigate = useNavigate();


  const handleCardClick = (id) => {
    navigate(`/products/${id}`);
  };

  return (
    <div className="products-page">
       <div className="products-title">
        <h1> PRODUCTS</h1>
        <p></p>
        
      </div>
      <div className="product-cards">
        {products.map((product) => (
          <div
            className="product-card"
            key={product.id}
            onClick={() => handleCardClick(product.id)}
          >
            <img src={product.image} alt={product.name} className="product-image" />
            <h2 className="product-name">{product.name}</h2>
            <p className="product-description">{product.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsPage;
